export default __webpack_public_path__ + "static/media/mark-as-paid-offline-icon.7569cede.svg";